module.exports = __webpack_public_path__ + "h5/img/sh.40341ce0.png";